import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    ActivityLogData: [],
    logCount: 0,
    isFetching: false,
    isActivityLogSuccess: false,
    isError: false,
    errorMessage: '',
};

export const getActivityLogs = createAsyncThunk(
    'api/activity',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/activity?limit=10&page=${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const ManageActivityLogSlice = createSlice({
    name: 'manageactivitylog',
    initialState,
    reducers: {
        clearStateActivityLogs: (state, { payload }) => {
            state.ActivityLogData = [];
            state.logCount = 0;
            state.isActivityLogSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },

    extraReducers: {
        [getActivityLogs.fulfilled]: (state, { payload }) => {
            state.ActivityLogData = payload.data.data;
            state.logCount = payload.data.count;
            state.isFetching = false;
            state.isActivityLogSuccess = true;
            return state;
        },
        [getActivityLogs.pending]: (state) => {
            state.isFetching = false;
        },
        [getActivityLogs.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateActivityLogs } = ManageActivityLogSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateActivityLogs());
    }
}

export const ManageActivityLogSelector = (state) => state.manageactivitylog;

export default ManageActivityLogSlice.reducer;
